import 'react-app-polyfill/ie11';

import App from './App';
import { BrowserRouter } from 'react-router-dom';
import React from 'react';
import ReactDOM from 'react-dom';
import { RecoilRoot } from 'recoil';
import RecoilizeDebugger from 'recoilize';
import ScrollToTop from './ScrollToTop';
import { QueryClient, QueryClientProvider } from 'react-query';
import { getAppBasename } from './utils/publicUrl';

const queryClient = new QueryClient();

ReactDOM.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <RecoilRoot>
        <RecoilizeDebugger />
        <BrowserRouter basename={getAppBasename()}>
          <ScrollToTop>
            <App />
          </ScrollToTop>
        </BrowserRouter>
      </RecoilRoot>
    </QueryClientProvider>
  </React.StrictMode>,
  document.getElementById('root')
);
